// extracted by mini-css-extract-plugin
export default {"single_rreview_tab":"awaiting-conffirm-rejcted_single_rreview_tab__znsem"};